module.exports = __webpack_public_path__ + "static/media/atendimento-1-mobile.da728ba7.png";